import { BASE_URL } from '../config';
import { getUserId } from '../functions/authHelpers';
import { fetchUser } from '../users/users';
import customFetch from './../../function/customFetch';
const origins = ['peppercontent.io', 'peppercontent.dev', 'localhost'];
export const login = async ({ username, password }) => {
    try {
        const response = await customFetch(`${BASE_URL}/login`, {
            method: 'POST',
            ...(typeof window !== 'undefined' &&
                origins.some(origin => window.location.origin.includes(origin)) && {
                credentials: 'include'
            }),
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: username,
                password: password
            })
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.token,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const googleAuth = async ({ token, type, role, pcSource, pcMedium }) => {
    try {
        const response = await customFetch(`${BASE_URL}/${type}/with-google`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token,
                role,
                pc_source: pcSource,
                pc_medium: pcMedium
            })
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.token,
                error: undefined
            };
        }
        else if (response.status === 409) {
            return {
                status: 'error',
                data: null,
                error: undefined,
                statusCode: response.status
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const refreshToken = async () => {
    try {
        const response = await customFetch(`${BASE_URL}/refresh-token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `${localStorage.getItem('authToken')}`
            }
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.token,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const refreshTokenFromCookie = async () => {
    try {
        const response = await customFetch(`${BASE_URL}/refresh-token`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.token,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const requestOTP = async ({ email, type }) => {
    try {
        const response = await customFetch(`${BASE_URL}/account/email-otps`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email_id: email,
                otp_type: type
            })
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.otp_id,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const requestSignupOTP = async ({ email, first_name }) => {
    try {
        const response = await customFetch(`${BASE_URL}/signup/send-otp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email_id: email,
                first_name: first_name
            })
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.otp_id,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const confirmSignup = async ({ email, otp_id, otp, first_name, last_name, phone, password, invite_code = undefined, role, user_invite_code, invite_hash, pcSource, pcMedium }) => {
    try {
        const response = await customFetch(`${BASE_URL}/signup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email_id: email,
                otp_id,
                otp,
                first_name,
                last_name,
                phone,
                password,
                invite_code,
                role,
                user_invite_code,
                invite_hash,
                pc_source: pcSource,
                pc_medium: pcMedium
            })
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const changePassword = async ({ old_password, new_password }) => {
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
    };
    try {
        const userId = getUserId();
        const response = await customFetch(`${BASE_URL}/users/${userId}/password`, {
            method: 'PUT',
            headers,
            body: JSON.stringify({
                current_password: old_password,
                new_password: new_password
            })
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.otp_id,
                error: undefined
            };
        }
        throw new Error(result.description || 'Unknown error occurred.');
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const resetPassword = async ({ email, otp_id, otp, password }) => {
    try {
        const response = await customFetch(`${BASE_URL}/account/reset-password`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email_id: email,
                otp_id,
                otp,
                password
            })
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result,
                error: undefined
            };
        }
        throw new Error(result.description || 'Unknown error occurred.');
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const getAuthUser = async () => {
    const userId = getUserId();
    if (userId === null)
        return {
            status: 'error',
            data: null,
            error: ''
        };
    const MAX_RETRIES = 10;
    let retries = 0;
    try {
        while (retries <= MAX_RETRIES) {
            const { status, data } = await fetchUser({ id: userId });
            if (status !== 'ok') {
                retries += 1;
                break;
            }
            return {
                status: 'ok',
                data,
                error: undefined
            };
        }
        throw new Error('Could not get user details');
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.meessage
        };
    }
};
export const validateInviteCode = async (id) => {
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
    };
    try {
        const response = await customFetch(`${BASE_URL}/signup/invite-codes/${id}`, {
            method: 'GET',
            headers
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.data,
                error: undefined
            };
        }
        throw new Error(result.description || 'Unknown error occurred.');
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
//# sourceMappingURL=auth.js.map